module.exports = __webpack_public_path__ + "img/ICONE-RDV-GREY.9871507f.svg";